import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OfferFrame } from '../api/_generated_';
import { OFFER_FRAME } from '../constants/queryKeys';
import useAxiosPrivate from './useAxiosPrivate';

export default function useOfferDetail() {
  const { id: uuid } = useParams();

  const { i18n } = useTranslation();

  const axios = useAxiosPrivate();

  async function fetchOffer() {
    const res = await axios.get<OfferFrame>(`/offers/${uuid}/frame?locale=${i18n.language}&withSampleRequests=true`);
    return res.data;
  }

  return useQuery({
    queryKey: [OFFER_FRAME, uuid],
    queryFn: fetchOffer,
  });
}
